<template>
<div class="page-content">
    <div class="container-fluid">

        <!-- start page title -->
        <div class="row justify-content-center">
            <div class="col-8">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0">Kelola Mata Pelajaran</h4>

                    <div class="page-title-right">
                        <ol class="breadcrumb m-0">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
                            </li>
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'courses_category' }">Mata Pelajaran</router-link>
                            </li>
                            <li class="breadcrumb-item active">Form Mata Pelajaran</li>
                        </ol>
                    </div>

                </div>
            </div>
        </div>
        <!-- end page title -->

        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex text-muted">
                            <div class="flex-shrink-0 me-3 align-self-center">
                                <div id="radialchart-1" class="apex-charts" dir="ltr"></div>
                            </div>
                            <div class="flex-grow-1 overflow-hidden">
                                <p class="mb-1">Silahkan lengkapi form dibawah ini</p>
                                <form class="mt-3" v-on:submit.prevent="onSubmit">
                                    <div class="form-group mb-3">
                                        <label class="form-label" for="code">Kode</label>
                                        <input class="form-control" type="text" id="name" v-model="form.code" placeholder="Masukan kode mata pelajaran">
                                    </div>

                                    <div class="form-group mb-3">
                                        <label class="form-label" for="name">Nama</label>
                                        <input class="form-control" :class="{ 'is-invalid': submitted && $v.form.name.$error }" type="text" id="name" v-model="form.name" placeholder="Masukan nama mata pelajaran">
                                        <div v-if="submitted && !$v.form.name.required" class="invalid-feedback">Name is required!</div>
                                    </div>

                                    <div class="form-group mb-3 row">
                                        <div class="col-md-6">
                                            <label class="form-label" for="study_program_id">Jurusan</label>
                                            <select class="form-select border-muted" v-model="form.study_program_id" :class="{ 'is-invalid': submitted && $v.form.study_program_id.$error }">
                                                <option value="">Semua Jurusan</option>
                                                <option v-for="row in program_study" :value="row.id" :key="row.id">{{row.name}}</option>
                                            </select>
                                            <div v-if="submitted && !$v.form.study_program_id.required" class="invalid-feedback">Program studi is required!</div>
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label" for="curriculum_id">Kurikulum</label>
                                            <select class="form-select border-muted" v-model="form.curriculum_id" :class="{ 'is-invalid': submitted && $v.form.curriculum_id.$error }">
                                                <option value="">Semua Kurikulum</option>
                                                <option v-for="row in curriculum" :value="row.id" :key="row.id">{{row.name}}</option>
                                            </select>
                                            <div v-if="submitted && !$v.form.curriculum_id.required" class="invalid-feedback">Kurikulum is required!</div>
                                        </div>
                                    </div>

                                    <div class="form-group mb-3 row">
                                        <div class="col-md-6">
                                            <label class="form-label" for="sks">Total Pertemuan</label>
                                            <input class="form-control" :class="{ 'is-invalid': submitted && $v.form.sks.$error }" type="text" id="sks" v-model="form.sks" placeholder="Masukan pertemuan mata pelajaran">
                                            <div v-if="submitted && !$v.form.sks.required" class="invalid-feedback">Total pertemuan is required!</div>
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label" for="status">Status</label>
                                            <select class="form-select border-muted" v-model="form.status">
                                                <option value="publish">Publish</option>
                                                <option value="unpublish">Unpublish</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="d-flex justify-content-end mt-4">
                                        <router-link :to="{name: 'courses_category'}" class="btn btn-light me-2"><i class="mdi mdi-arrow-left me-2"></i>Batal</router-link>
                                        <button type="submit" class="btn btn-primary"><i class="mdi mdi-content-save me-2"></i>Simpan</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->

    </div>
    <!-- container-fluid -->
</div>
</template>

<script>
import {
    required
} from "vuelidate/lib/validators";
export default {
    name: 'FormCoursesCategory',
    metaInfo: {
        title: "Form Mata Pelajaran",
        titleTemplate: "%s - Elearning"
    },
    data() {
        return {
            id: this.$route.params.id,
            submitted: false,
            waiting: false,
            program_study: [],
            curriculum: [],
            form: {
                code: '',
                name: '',
                study_program_id: '',
                curriculum_id: '',
                sks: '',
                status: 'unpublish',
            },
        }
    },
    validations: {
        form: {
            code: {
                required
            },
            name: {
                required
            },
            study_program_id: {
                required
            },
            curriculum_id: {
                required
            },
            sks: {
                required
            },
        }
    },
    created() {
        this.fetchDetail();
        this.fetchProgramStudy();
        this.fetchCurriculum();
    },
    methods: {
        createSlug: function (text) {
            return text.toLowerCase()
                .replace(/ /g, '-')
                .replace(/[^\w-]+/g, '')
        },
        generateSlugCode() {
            this.form.code = this.createSlug(this.form.name)
        },
        onSubmit: function () {
            this.waiting = true;
            this.submitted = true;

            // stop here if form is invalid
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Please complete the form',
                });

                this.waiting = false;
                return;
            } else {
                let formData = new FormData();

                for (var index in this.form) {
                    formData.append(index, this.form[index]);
                }

                this.$http.post(process.env.VUE_APP_APIHOST + 'administrator/courses-category/save', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push({
                                        name: 'courses_category'
                                    });
                                }
                            });
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: response.data.message,
                            });
                        }
                        this.waiting = false;
                    })
                    .catch(function () {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: 'Please check your internet connection.',
                        });
                        this.waiting = false;
                        return;
                    });

            }
        },
        fetchDetail: function() {
            if (typeof (this.id) !== 'undefined' && this.id !== null) {
                this.label  = "Update";

                let uri     = process.env.VUE_APP_APIHOST+'administrator/courses-category/detail';

                this.dataFetch  = true;                
                this.$http.get(uri,{
                    params : {
                        id : this.id
                    }
                }).then(res => {
                    if(res.data.status) {
                        let getResponse = res.data.data;
                        this.form       = getResponse;
                    } else {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: res.data.message,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                this.$router.push({ name: 'courses_category' });
                            }
                        });
                    }
                });
            }
        },
        fetchProgramStudy: function () {
            let uri = process.env.VUE_APP_APIHOST + 'program-study/list';

            this.dataFetch = true;
            this.$http.get(uri).then(res => {
                if (res.data.status) {
                    let getResponse = res.data.data;
                    this.program_study = getResponse;
                }
            });
        },
        fetchCurriculum: function () {
            let uri = process.env.VUE_APP_APIHOST + 'curriculum/list';

            this.dataFetch = true;
            this.$http.get(uri).then(res => {
                if (res.data.status) {
                    let getResponse = res.data.data;
                    this.curriculum = getResponse;
                }
            });
        },
    },
}
</script>
